export default {
  namespaced: true,
  state: {
    aimList: [],
    aimTypes: [], // 意图列表
    combine: [], // 已关联的意图
    editForm: {
      quesiton: {
        intent_code: '',
        question: '',
      },
      reply: {},
    }, // 编辑表单
    replyList: [],
    currentItem: {}, // 当前回复
    slotList: [],
    questionForm: {
      // 修改标准问法
      intent_name: '',
      question: '',
      intent_code: '',
    },
    slotForm: {
      // 异常管理
      btm_norec: '',
      btm_nores: '',
      retry_times: 1,
      err_action: 1,
      err_code: '',
      status: 2,
    },
    transfer: null,
    combineSlot: [], // 已关联的槽值
  },
  mutations: {
    setAimList(state, aimList) {
      state.aimList = aimList
    },
    setCombine(state, combine) {
      state.combine = combine
    },
    setIntentCode(state, intent_code) {
      state.intent_code = intent_code
    },
    setReplyList(state, replyList) {
      state.replyList = replyList
      state.currentItem = replyList.length > 0 ? state.replyList[0] : {}
    },
    setSlotList(state, slotList) {
      state.slotList = slotList
    },
    addItem(state, item) {
      state.replyList = [...state.replyList, item]
      state.currentItem = item
    },
    deleteItem(state, { currentIndex, showIndex }) {
      state.replyList.splice(currentIndex, 1)
      state.currentItem = showIndex > -1 ? state.replyList[showIndex] : {}
    },
    setQuestionForm(state, form) {
      state.questionForm = form
    },
    setSlotForm(state, form) {
      state.slotForm = form
    },
    setSlotFormVal(state, item) {
      state.slotForm = { ...state.slotForm, ...item }
    },
    setTransfer(state, transfer) {
      state.transfer = transfer
    },
    setCurrentItem(state, currentIndex) {
      state.currentItem = state.replyList[currentIndex]
    },
    setCombineSlot(state, combineSlot) {
      state.combineSlot = combineSlot
    },
  },
}
